import { render, staticRenderFns } from "./PinBoard.vue?vue&type=template&id=3a74e527&scoped=true&"
import script from "./PinBoard.vue?vue&type=script&lang=ts&"
export * from "./PinBoard.vue?vue&type=script&lang=ts&"
import style0 from "./PinBoard.vue?vue&type=style&index=0&id=3a74e527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74e527",
  null
  
)

export default component.exports